import api, { setHeaderToken, removeHeaderToken } from "../../../apis/Api";
import config from "../../../config";

import router from "@/router";
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    invoiceList: [],
    trxList: [],
    invoiceDetail: { Invoice_item: [] },
    trxDetail: {},
    faktur: ""
  },
  getters: {
    getInvoiceList(state) {
      return state.invoiceList;
    },
    getInvoiceDetail(state) {
      return state.invoiceDetail;
    },
    getTrxList(state) {
      return state.trxList;
    },
    getTrxDetail(state) {
      return state.trxDetail;
    },
    getFaktur(state) {
      return state.faktur;
    }
  },
  mutations: {
    setInvoiceList(state, payload) {
      state.invoiceList = payload;
    },
    setInvoiceDetail(state, payload) {
      state.invoiceDetail = payload;
    },
    setTrxList(state, payload) {
      state.trxList = payload;
    },
    setTrxDetail(state, payload) {
      state.trxDetail = payload;
    },
    setFaktur(state, payload) {
      state.faktur = payload;
    }
  },
  actions: {
    postInvoice({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          baseURL: config("api.baseUrl_billing"),
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    getList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_billing"),
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            if (payload.url == "invoices/list") {
              commit("setInvoiceList", res.respond.data);
            } else {
              commit("setTrxList", res.respond.data);
            }
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getDetail({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_billing"),
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            if (payload.url == "invoices/detail") {
              commit("setInvoiceDetail", res.respond.data);
            } else if (payload.url == "invoices/get/faktur") {
              commit("setFaktur", res.respond.data.filename);
            } else {
              commit("setTrxDetail", res.respond.data);
            }
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => {});
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    setLoading({ commit }, payload) {
      commit("loader/setLoading", payload, {
        root: true
      });
    }
  }
};
